var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Main2',{attrs:{"id":"main"}},[_c('router-view',{attrs:{"slot":"sider","name":"sider"},slot:"sider"}),_c('router-view',{style:({'minHeight':_vm.contentHeight}),attrs:{"slot":"content"},slot:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }